import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

export type Ball =
  | 'skull'
  | 'red'
  | 'yellow'
  | 'white'
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | number;

@Component({
  selector: 'lib-ball',
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './ball.component.html',
  styleUrl: './ball.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    ['[class.large]']: 'large()',
  },
})
export class BallComponent {
  readonly ball = input.required<Ball>();
  readonly large = input(false);
  readonly descriptiveAltText = input(false);
  readonly alt = computed(() =>
    this.descriptiveAltText() ? `${this.ball()} ball` : this.ball(),
  );
}
